module.exports = __webpack_public_path__ + "static/media/21ECLAC48.e5a8dda4.jpg";